import { ModalOrOffcanvas } from '../modal';
import { ContactForm, InitForm } from '../contact-form';
import i18n from '../i18n';
import * as template from 'smg/template';

if (document.body.id === 'contact') {
    main();
}

function main() {
    const $form = document.querySelector('#contact-form') as HTMLFormElement;
    const $formTemplate = document.querySelector('#contact-form-template') as HTMLTemplateElement;
    ContactForm($form, $formTemplate);

    const $formOpen = document.querySelector<HTMLButtonElement>('#contact-us-form-open');

    $formOpen?.addEventListener('click', () => {
        const $modalFormTemplate = document.querySelector('#contact-form-modal-template') as HTMLTemplateElement;
        const $body = template.Clone($modalFormTemplate).firstElementChild as HTMLElement;

        new ModalOrOffcanvas({
            title: i18n('contactSendUsANote'),
            body: $body,
            appendClassBySelector: {
                '.modal-footer': 'd-none',
                '.offcanvas-footer': 'd-none',
            },
            onSubmit: InitForm($body, 'modal-'),
        });
    });
}
